import React, {useEffect, useRef} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import {Flex} from "reflexbox";

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import PageHeader from "../gamePlayComponents/PageHeader";
import SkeletonImage from "../common/SkeletonImage";
import {END, ToSummary} from "../helpers/routes";
import CardMedia from "@mui/material/CardMedia";
import {useSelector} from "react-redux";
import Reward from "react-rewards";
import {fetchCourseContent} from "../courseContent/courseObjects";
import {newLocation} from "../courseContent/questionTypes";
import { getDatabase, ref, update } from "firebase/database";
import {getTimeAndScore} from "../../helpers/gameUtils";
import {writeTeamProgress, writeUserCourseCompletion} from "../../helpers/dbFunctions";

const TheEnd = (props) => {
  const {course} = useParams();
  const currentCourseName = course || null;
  const { currentTeamId, teamDetails } = useSelector((state) => state.team);
  const { uid } = useSelector((state) => state.user || {});
  const courseProgress = teamDetails?.courseProgress?.[currentCourseName];
  const teamName = teamDetails?.teamName || "Anonymous";
  const memberIds = teamDetails?.memberIds || [];
  let navigate = useNavigate();
  const rewardRef = useRef(null);

  //calculating total score
  const {pointsFromQs, completedQuestionTime, questionsCorrect, totalQuestions} = getTimeAndScore(teamDetails.questions, currentCourseName);
  //const remainingTime = Math.max(countDownStartNum - completedQuestionTime, 0);
  const timeBonus = completedQuestionTime ? Math.max(0, Math.min(1, 1/completedQuestionTime)) : 0;
  const totalPoints = pointsFromQs + timeBonus;

  useEffect(()=> {
      //conditional so that we don't make unnecessary redux state or db calls
      if(!courseProgress?.toString().includes(END)) {
        //update course progress so that if the game reloads we don't have the modal to resume course
        writeTeamProgress(currentTeamId, currentCourseName, props?.location?.pathname || '/end');
        //post to leaderboard back-end
        const leaderboardPayload = {
          teamName: teamName,
          time: completedQuestionTime,
          totalScore: totalPoints,
          pointsFromQs: pointsFromQs,
          qsCorrect: questionsCorrect,
          totalQs: totalQuestions,
          completedAt: new Date().toISOString(),
          memberIds: memberIds,
          teamId: currentTeamId,
        };
        const db = getDatabase();
        update(ref(db, `/leaderboard/${currentCourseName}/${currentTeamId}`), leaderboardPayload).catch(() => {});

        // update the current user's profile with this course completion
        if (uid) {
          const completionPayload = {
            courseName: currentCourseName,
            teamId: currentTeamId,
            teamName,
            time: completedQuestionTime,
            totalScore: totalPoints,
            pointsFromQs,
            qsCorrect: questionsCorrect,
            totalQs: totalQuestions,
            completedAt: new Date().toISOString(),
          };
          writeUserCourseCompletion(uid, currentCourseName, completionPayload);
        }
      }
  }, [courseProgress, currentTeamId, currentCourseName, completedQuestionTime, pointsFromQs, questionsCorrect, totalQuestions, totalPoints, teamName, uid]);

  //trigger confetti shortly after page load
  useEffect(() => {
    setTimeout(() => rewardRef.current?.rewardMe(), 300);
  });

  const courseContent= fetchCourseContent(currentCourseName);

  if (!courseContent) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant="h6" color="error">
          Course not found: {currentCourseName}
        </Typography>
        <Typography>
          Please select a valid course from the course selector.
        </Typography>
      </div>
    );
  }

  const imageSources = new Set();

  for (const el in courseContent) {
    if (courseContent[el]?.type === newLocation ) {
      imageSources.add(courseContent[el]?.location.img)
    }
  }

  let images = [];

  imageSources.forEach((val, key) => {
      images.push(<Card key={key} style={{width: '49%', marginBottom: '8px'}} onClick={()=> rewardRef.current?.rewardMe()}>
        <CardMedia id={'card media'} >
          <SkeletonImage greenOverlay skeletonHeight={'175px'} src={val} alt={'location'} style={{height: '100%'}}/>
        </CardMedia>
      </Card>)
    }
  );

  return (<Flex style={{flexDirection: 'column'}}>
      <PageHeader title={'The End'} hamburgerMenu currentCourse={currentCourseName} />
      <Card>
        <CardContent>
          <Flex style={{flexDirection: 'column'}}>
          <Typography>You made it! Great job solving so many tricky clues. We hope you had as much fun as we did making
            the course for you.</Typography>
          <Typography style={{marginTop: '16px'}} >If you post on social media, tag us @CapitalClues !</Typography>
          </Flex>
        </CardContent>
        <CardActions style={{justifyContent: 'flex-end'}}>
          <Button variant={'contained'} color={'primary'} onClick={() => navigate(ToSummary(currentCourseName))}>See Results</Button>
        </CardActions>
        <Flex style={{justifyContent: 'center'}}>
          <Reward type='confetti' ref={rewardRef} config={{ springAnimation: false, lifetime: 360, elementSize: 9, zIndex: 5, containerStyle: { pointerEvents: 'none' } }}>
            <div  style={{height: '1px', width: '1px', backgroundColor: 'white'}} />
          </Reward>
        </Flex>
      </Card>
      <Flex style={{flexWrap: 'wrap', paddingTop: '8px', justifyContent: 'space-between'}}>
        {images}
      </Flex>
    </Flex>
  )
};

export default TheEnd;
